import React from 'react';
import { Helmet } from 'react-helmet';
import App from '../components/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';

export default () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>zachary d eager</title>
        <html lang="en" />
        <meta name="title" content="zachary d eager" />
        <meta name="description" content="dev, researcher, educator" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://zdeager.com/" />
        <meta property="og:title" content="zachary d eager" />
        <meta property="og:description" content="dev, researcher, educator" />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://zdeager.com/" />
        <meta property="twitter:title" content="zachary d eager" />
        <meta property="twitter:description" content="dev, researcher, educator" />
      </Helmet>
      <App />
    </>
  );
};
